module.exports = __webpack_public_path__ + "img/tc.95f6ee5f.png";